(() => {
  const variantId = value => String(value ?? '').replace(/^gid:\/\/shopify\/ProductVariant\//, '');
  const properties = (items, box, expected) => {
    if (!box || variantId(box.platformId) !== variantId(expected.variantId) || Number(box.size) !== expected.size) throw new Error('The selected box is not configured in Skio.');
    if (box.sellingPlan && String(box.sellingPlan) !== String(expected.sellingPlanId)) throw new Error('The box subscription plan has changed.');
    const allowed = new Set((box.selectableProductVariants || []).map(item => variantId(item.platformId)));
    const quantities = new Map();
    for (const item of items) {
      const id = variantId(item.variantId);
      if (!/^\d+$/.test(id) || !allowed.has(id) || !Number.isInteger(item.qty) || item.qty < 1) throw new Error('A selected product is not available in this Skio box.');
      quantities.set(id, (quantities.get(id) || 0) + item.qty);
    }
    if ([...quantities.values()].reduce((sum, qty) => sum + qty, 0) !== expected.size) throw new Error('The selected products do not fill this box.');
    return Object.fromEntries([...quantities].map(([id, qty]) => [`_pvgid://shopify/ProductVariant/${id}`, qty]));
  };
  const fetchBox = async plan => {
    const response = await fetch('https://api.skio.com/storefront-http/get-classic-box-v2', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productVariantPlatformId: String(plan.variantId), sellingPlanPlatformId: String(plan.sellingPlanId) })
    });
    const payload = await response.json();
    if (!response.ok || payload.ok === false || !payload.ClassicBoxV2) throw new Error('The selected box could not be verified with Skio.');
    return payload.ClassicBoxV2;
  };
  window.CarlsSkioBox = { properties, fetchBox };
})();
